import React from 'react'
import {Modal} from 'react-bootstrap';
import {logoutUser} from '../lib/localStorage'
import { NavLink ,useNavigate } from 'react-router-dom'

function LogoutModal({show,handleClose}) {
  const navigate = useNavigate();

 const  onLogoutClicks = (e) => {
    e.preventDefault();
    logoutUser();
    navigate('/')
  }



  return (
   <>
   <Modal centered className='cmn_modal'
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        
        <Modal.Body>
            <div className='cmn_modal_header d-flex justify-content-between align-items-center'>
                <p className='cmn_modal_title'>Logout</p>
                <button className='cmn_modal_closer rounded-5' onClick={handleClose}><i class="fa-solid fa-xmark"/></button>
            </div>

            <div className='mt-3'>
            
            <p className='text-white mb-0'>Are you sure to logout?</p>
                <button className='btn addcate px-3 py-2 mt-4 mb-3' onClick={(e)=>{onLogoutClicks(e)}}>Logout</button>
            </div>
         
        </Modal.Body>
       
      </Modal>

   </>
  )
}

export default LogoutModal